import React, { useContext } from "react";
import PropTypes from "prop-types";
import Link from "ui/Link";
import Reveal from "ui/Reveal";
import { GlobalContext } from "GlobalContext";
import TrainingCard from "components/TrainingCard";

import {
  TrainingsBlockWrapper,
  TrainingsGrid,
  TrainingsIntro,
  IntroContainer,
  Title,
  Description,
} from "./styles/TrainingsBlockStyles";

const TrainingsBlock = ({ formationsData }) => {
  const { navigateTo } = useContext(GlobalContext);
  const {
    titreRubrique,
    description,
    imageArrierePlan,
    formations,
    labelToutesLesFormations,
    lienToutesLesFormations,
  } = formationsData;
  return (
    <React.Fragment>
      <TrainingsBlockWrapper
        className="formations-block"
        bg={imageArrierePlan ? imageArrierePlan.sourceUrl : ""}
      >
        <div className="fixed-container">
          <TrainingsGrid>
            <Reveal stretch>
              <TrainingsIntro>
                <IntroContainer>
                  <Title
                    className="secondary"
                    dangerouslySetInnerHTML={{ __html: titreRubrique }}
                  />
                  <Description
                    dangerouslySetInnerHTML={{ __html: description }}
                  />
                </IntroContainer>
              </TrainingsIntro>
            </Reveal>
            {formations &&
              formations.map((formation, i) => (
                <Reveal stretch key={i} delay={((i + 1) % 3) * 120}>
                  <TrainingCard data={formation.formation} />
                </Reveal>
              ))}
          </TrainingsGrid>
          <Link label={labelToutesLesFormations} color="white" onClick={() => navigateTo(lienToutesLesFormations)} />
        </div>
      </TrainingsBlockWrapper>
    </React.Fragment>
  );
};

TrainingsBlock.propTypes = {};

TrainingsBlock.defaultProps = {};

export default TrainingsBlock;
